const reportWebVitals = (onPerfEntry?: any) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      try {
        getCLS && getCLS(onPerfEntry);
        getFID && getFID(onPerfEntry);
        getFCP && getFCP(onPerfEntry);
        getLCP && getLCP(onPerfEntry);
        getTTFB && getTTFB(onPerfEntry);
      } catch (e) {
        console.log('Web Vitals error:', e);
      }
    });
  }
};

export default reportWebVitals; 